import { render, staticRenderFns } from "./ListMaterialsByType.vue?vue&type=template&id=055c7c00"
import script from "./ListMaterialsByType.vue?vue&type=script&lang=js"
export * from "./ListMaterialsByType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports